import React, { useContext } from 'react'

import { Button } from '~/components/Form'
import Modal from '~/components/Modal'

import { TutorialContext } from '~/contexts/TutorialContext'

import Cadastrar from './Cadastrar'
import Listagem from './Listagem'

import { Container } from './styles'

export default function () {
    const {
        showCadastroTutorial, setShowCadastroTutorial, editTutorial, setEditTutorial 
    } = useContext(TutorialContext)

    return (
        <Container>
            <Button className="transparent" onClick={() => { setShowCadastroTutorial(true) }}>
                Cadastrar
            </Button>

            <Listagem />

            <Modal
                isOpen={showCadastroTutorial || !!editTutorial}
                handleClose={() => { 
                    setShowCadastroTutorial(false) 
                    setEditTutorial(null)
                }}
                title="Cadastro de tutoriais"
            >
                <Cadastrar />
            </Modal>
        </Container>
    )
}
